__turbopack_context__.v({
  "fadeIn": "Navbar-module__NpnVta__fadeIn",
  "fadeInIndicator": "Navbar-module__NpnVta__fadeInIndicator",
  "fadeOut": "Navbar-module__NpnVta__fadeOut",
  "navbarWrapper": "Navbar-module__NpnVta__navbarWrapper",
});
